export default "__VITE_ASSET__06d40f05__"